var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIntroductionSecurite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.4 64c-0.17 0-0.342-0.029-0.506-0.083-5.885-1.962-13.27-8.483-18.816-16.618-5.053-7.411-11.078-19.693-11.078-36.102 0-0.883 0.717-1.6 1.6-1.6 9.005 0 23.162-6.163 27.914-9.331 0.538-0.358 1.238-0.358 1.776 0 4.752 3.168 18.909 9.331 27.914 9.331 0.883 0 1.6 0.717 1.6 1.6 0 16.41-6.026 28.688-11.078 36.102-5.546 8.131-12.931 14.656-18.816 16.618-0.163 0.054-0.336 0.083-0.506 0.083h-0.003zM3.219 12.749c0.362 14.819 5.862 25.946 10.502 32.752 5.661 8.301 12.339 13.536 16.678 15.203 4.339-1.667 11.018-6.899 16.678-15.203 4.64-6.806 10.141-17.933 10.502-32.752-5.21-0.326-11.014-2.118-15.136-3.648-4.538-1.68-9.117-3.818-12.045-5.603-2.928 1.786-7.507 3.923-12.045 5.603-4.125 1.526-9.926 3.322-15.136 3.648v0z",
    fill: "#223654"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.2 40c-0.41 0-0.819-0.157-1.133-0.467l-6.4-6.4c-0.624-0.624-0.624-1.638 0-2.262s1.638-0.624 2.262 0l5.267 5.267 14.867-14.867c0.624-0.624 1.638-0.624 2.262 0s0.624 1.638 0 2.262l-16 16c-0.314 0.314-0.723 0.467-1.133 0.467h0.006z",
    fill: "#223654"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntroductionSecurite);
export default __webpack_public_path__ + "static/media/introduction-securite.9e6db7aa736847030f6f6c501fb5942f.svg";
export { ForwardRef as ReactComponent };